module.exports = __webpack_public_path__ + "img/bechtle.e31c1951.png";